import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AnimationOptions } from 'ngx-lottie';
import { SignUpVerification } from 'src/app/shared/services/auth-service/sign-up-verification.service';
@Component({
    selector: 'app-sign-up-verified',
    templateUrl: './sign-up-verified.component.html',
    styleUrls: ['./sign-up-verified.component.scss'],
})
export class SignUpVerifiedComponent implements OnInit {
    options: AnimationOptions = {
        path: '/assets/images/reset_link_sent.json',
    };
    errorMessage: any;
    getToken: any;
    constructor(
    private signUpService: SignUpVerification,
    private activatedRoute: ActivatedRoute
    ) {}
    ngOnInit() {
        this.activatedRoute.queryParams.subscribe(async (params) => {
            this.getToken = params['token'];

            (await this.signUpService.verification(this.getToken)).subscribe(
                (data: any) => {
                    if (data.length == 0) {
                        this.errorMessage = true;
                    } else {
                        this.errorMessage = false;
                    }
                }
            );
        });
    }
}
